import React, { useState } from "react";
import Logo from "./Logo";
import "./AuthFlow.css";

import IMG_LOCATION_BG from "../../assets/images/location_bg.png";

function BriefcaseIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="6.5" width="16" height="10.5" rx="2" stroke="#3C3C3C" strokeWidth="1.3" />
      <path d="M7 6.5V4.8A1.8 1.8 0 018.8 3h2.4A1.8 1.8 0 0113 4.8v1.7" stroke="#3C3C3C" strokeWidth="1.3" />
      <path d="M2 11h16" stroke="#3C3C3C" strokeWidth="1.3" />
    </svg>
  );
}
function SearchIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
      <circle cx="6.3" cy="6.3" r="5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M10 10l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
function PinIconSmall() {
  return (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="none">
      <path d="M6 14.4S11.4 9 11.4 5.7a5.4 5.4 0 10-10.8 0C.6 9 6 14.4 6 14.4z" fill="#C0392B" />
      <circle cx="6" cy="5.7" r="2" fill="#fff" />
    </svg>
  );
}
function ForkKnifeIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <path d="M2.2 1v4.4a1.3 1.3 0 002.6 0V1M3.5 5.4V12M9.8 1c-1 0-1.8 1.4-1.8 3.1s.8 3.1 1.8 3.1V12" stroke="#C0392B" strokeWidth="1" strokeLinecap="round" />
    </svg>
  );
}
function Star({ filled }) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M6 .6l1.6 3.4 3.7.4-2.7 2.6.7 3.7L6 9l-3.3 1.7.7-3.7L.7 4.4l3.7-.4L6 .6z"
        fill={filled ? "#F5A623" : "#E0E0E0"}
      />
    </svg>
  );
}

function RatingStars({ value }) {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(<Star key={i} filled={value >= i - 0.5} />);
  }
  return <span className="auth-rating-stars">{stars}</span>;
}

const MOCK_RESULTS = [
  { name: "Bostin Pizza", reviews: "653", price: "$20–30", rating: 3.7, type: "Pizza restaurant", address: "5845 Trans-Canada Hwy, Duncan, BC V9L 3R9, Canada" },
  { name: "Bostin Pizza", reviews: "7,345", price: "₹₹", rating: 4.5, type: "Pizza restaurant", address: "250 Front St W Unit 1c201, Toronto, ON M5V 3G5, Canada" },
  { name: "Bostin Pizza", reviews: "1,768", price: "$20–30", rating: 3.7, type: "Pizza restaurant", address: "808 Beatty St, Vancouver, BC V6B 1C2, Canada" },
  { name: "Bostin Pizza", reviews: "3,084", price: "₹₹", rating: 4.5, type: "Pizza restaurant", address: "2458 Queen St E, Brampton, ON L6S 5X9, Canada" },
];

export default function LocationSearchPage({ onSelectBusiness }) {
  const [query, setQuery] = useState("Boston Pizza");
  const [searched, setSearched] = useState(false);

  const handleSearch = () => {
    if (query.trim()) setSearched(true);
  };

  return (
    <div className="auth-page auth-simple-page">
      <img src={IMG_LOCATION_BG} alt="" className="auth-simple-bg" />
      <header className="auth-navbar auth-navbar-simple">
        <Logo />
      </header>

      <div className="auth-card-wrap">
        <div className={`auth-card auth-card-wide${searched ? " auth-card-results" : ""}`}>
          <h1 className="auth-form-title auth-location-title">
            Where Businesses<br />Create <strong>Winning Deals</strong>.
          </h1>

          {!searched ? (
            <>
              <div className="auth-google-label">
                Find your business on <GoogleWordmark />
              </div>
              <label className="auth-field auth-field-plain">
                <BriefcaseIcon />
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Enter your business name"
                />
              </label>
              <button type="button" className="auth-btn auth-btn-outline auth-search-btn" onClick={handleSearch}>
                Search <SearchIcon />
              </button>
            </>
          ) : (
            <>
              <div className="auth-field-label auth-search-label">Search Your Business Name</div>
              <label className="auth-field auth-field-plain">
                <BriefcaseIcon />
                <input type="text" value={query} onChange={(e) => setQuery(e.target.value)} />
              </label>

              <div className="auth-results-list">
                {MOCK_RESULTS.map((r, i) => (
                  <button
                    type="button"
                    className="auth-result-row"
                    key={i}
                    onClick={() => onSelectBusiness?.(r)}
                  >
                    <div className="auth-result-top">
                      <span className="auth-result-name">
                        {r.name} <span className="auth-result-reviews">({r.reviews})</span>
                        {r.price && <span className="auth-result-price"> · {r.price}</span>}
                      </span>
                      <span className="auth-result-rating">
                        {r.rating} <RatingStars value={r.rating} />
                      </span>
                    </div>
                    <div className="auth-result-line"><ForkKnifeIcon /> {r.type}</div>
                    <div className="auth-result-line"><PinIconSmall /> {r.address}</div>
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function GoogleWordmark() {
  return (
    <svg width="62" height="20" viewBox="0 0 62 20" style={{ verticalAlign: "middle", marginLeft: 4 }}>
      <text x="0" y="15" fontFamily="Arial,Helvetica,sans-serif" fontSize="16" fontWeight="600">
        <tspan fill="#4285F4">G</tspan>
        <tspan fill="#EA4335">o</tspan>
        <tspan fill="#FBBC05">o</tspan>
        <tspan fill="#4285F4">g</tspan>
        <tspan fill="#34A853">l</tspan>
        <tspan fill="#EA4335">e</tspan>
      </text>
    </svg>
  );
}